import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import { Login } from './pages/login/Login';

const AppWrapper = (props: any) => {
    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <Routes>
            <Route path="/" element={<Login />} />

            <Route path="*" element={<App />} />
        </Routes>
    );
};

export default AppWrapper;
